import styled, {css} from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

interface IGroupFiltersListGroupTitleActivePreviewBoxProps {
    isVisible: boolean;
}

const PreviewDefaultBox = styled.span<IGroupFiltersListGroupTitleActivePreviewBoxProps>`

    @keyframes introAnimation {
        0% {
            opacity: 0;
            max-height: 0;
        }
        50% {
          opacity: 0;
          max-height: 20px;
        }
        100% {
            opacity: 1;
            max-height: 20px;
        }
    }

    display: block;
    opacity: 0;
    font-size: 11px;
    color: ${props => props.theme.colors.brandPrimary};
    ${({theme}) => theme.font.presets.regular};
    text-transform: capitalize;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    max-height: 0;

    ${props => props.isVisible && css`
      animation: 0.1s introAnimation 0.2s ease-in forwards;
    `}
`;

const PreviewMrGreenBox = styled(PreviewDefaultBox)`
    color: ${props => props.theme.colors.text};
`;

const PreviewSIBox = styled(PreviewDefaultBox)`
    color: ${props => props.theme.colors.textContrast};
    font-size: 11px;
     ${({theme}) => theme.font.presets.light};
`;

export const PreviewBox = styledByTheme(PreviewDefaultBox)
    .forSI(PreviewSIBox)
    .forSICis(PreviewSIBox)
    .forMrGreen(PreviewMrGreenBox)
    .forMrGreenCis(PreviewMrGreenBox).apply();
